/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 11] */
(function() {
    'use strict';
    var SearchModel = require('../models/search.model');
    var defaultSearchData = require('../data/search_default_data');
    var SearchController = function(widgets, opts) {
        this.searchModel = SearchModel.getInstance();
        this.defaultParams = defaultSearchData.get();
        this.opts = Odigeo._.extend({
            searchParam: 'lastSearchDynpack',
        }, opts);
        this.init(Odigeo.autoloadWidgetsAsync(widgets));
    };

    Odigeo._.extend(SearchController.prototype, {
        init: function(widgets) {
            Odigeo._.each(widgets, function(widgetFn) {
                widgetFn();
            });

            return this;
        },

        reset: function() {
            this.remove().restoreSearchParams();

            return this;
        },

        resetWithEmptyDestination: function() {
            this.remove().restoreSearchParamsWithEmptyDestination();

            return this;
        },

        hasPreviousSearch: function() {
            return !Odigeo._.isEmpty(this.getStorageParams()) || this.searchModel.hasSearchData();
        },

        hasPreviousValidSearch: function() {
            return this.hasPreviousSearch() && Odigeo._.isEmpty(this.getSearchErrors());
        },

        restoreSearchParams: function(force) {
            var storageParams;
            if (!force && this.searchModel.hasSearchData()) {
                return this;
            }
            storageParams = this.getStorageParams();
            this.setSearchParams(Odigeo._.isEmpty(storageParams) ? this.defaultParams : storageParams);
            return this;
        },

        restoreSearchParamsWithEmptyDestination: function() {
            if (this.searchModel.hasSearchData()) {
                return this;
            }

            var searchParams = this.getStorageParams();

            if (searchParams) {
                if (searchParams.accommodationDestination) {
                    delete searchParams.accommodationDestination;
                }
                searchParams.searchSegments[0].destination = this.defaultParams.searchSegments[0].destination;
                searchParams.searchSegments[1].departure = this.defaultParams.searchSegments[1].departure;
            } else {
                searchParams = this.defaultParams;
            }

            this.setSearchParams(searchParams);

            return this;
        },

        getStorageParams: function() {
            var storageClass = this.getStorageClass();
            return Odigeo.Utils.parseJson(storageClass.get(this.opts.searchParam));
        },

        getStorageClass: function() {
            var storageClassMap = {
                lastSearchDynpack: Odigeo.Storage,
                searchParameters: Odigeo.Session,
                lastSearch: Odigeo.PageStorage,
            };

            return storageClassMap[this.opts.searchParam] || Odigeo.Session;
        },

        getSearchErrors: function(config) {
            return this.searchModel.validation(config);
        },

        isValid: function() {
            return !Odigeo._.isEmpty(this.getSearchParams()) && Odigeo._.isEmpty(this.searchModel.errors);
        },

        extendSearchParams: function(params) {
            this.restoreSearchParams();
            return this.setSearchParams($.extend(true, {}, this.defaultParams, params));
        },

        setSearchParams: function(searchParams) {
            this.searchModel.fetch(Odigeo._.omit(searchParams, this.opts.omittedParams));

            return this;
        },

        getSearchParams: function() {
            return this.searchModel.toJSON();
        },

        remove: function() {
            this.searchModel.clear();

            return this;
        },
    }, Backbone.Events);

    module.exports = SearchController;
}());
